/* ============================================================
   Rangée de médias horizontale (style Peak Performance)
   Thème ciao-outdoor (base Dawn 15.4.1)

   Ce fichier :
   1. ajoute les deux flèches de défilement sur ordinateur;
   2. n'affiche que les médias de la couleur sélectionnée;
   3. place la vidéo en deuxième position;
   4. démarre les vidéos en boucle, sans son;
   5. copie les pastilles de couleur sous les photos, sur téléphone.

   La mise en page, elle, appartient entièrement à
   variant-media-row.css. Ce fichier ne pose aucun style.

   Deux méthodes pour reconnaître la couleur d'un média, dans
   cet ordre :

   A. Le texte alternatif de l'image contient le nom de la
      couleur (ex. « blanc - face »). Prioritaire dès qu'au
      moins une image de la couleur choisie en porte le nom.

   B. Le regroupement des médias. Dans Produits > Médias, les
      médias sont placés en blocs par couleur, et la PREMIÈRE
      image de chaque bloc est assignée aux variantes de cette
      couleur (c'est ce qui fait apparaître la bonne photo au
      changement de couleur). Le script déduit alors que tout
      ce qui suit cette image, jusqu'à l'image de la couleur
      suivante, appartient à cette couleur.

   Si aucune des deux ne s'applique, tous les médias restent
   affichés plutôt que d'avoir une rangée vide.
   ============================================================ */

(function () {
  var FILTRER_PAR_COULEUR = true;

  // Sur téléphone, un seul média est visible à la fois, et la vidéo est
  // en deuxième position. Mettre true ci-dessous la place en première
  // position sur téléphone : elle est alors à l'écran dès l'ouverture,
  // ce qui est la situation la plus favorable pour que le navigateur la
  // démarre seul. Sur ordinateur, l'ordre reste photo puis vidéo.
  var VIDEO_EN_PREMIER_SUR_MOBILE = false;

  // Le format et le cadrage des cases sont entièrement gérés par
  // variant-media-row.css. Ce fichier ne touche pas à la mise en page.

  // Repères de dépannage, lisibles dans la console du navigateur :
  // VMR_VERSION indique quelle version du fichier est réellement
  // chargée, VMR_ERREUR garde la trace d'une erreur éventuelle.
  window.VMR_VERSION = '29';
  window.VMR_ERREUR = null;
  window.VMR_PASSAGES = 0;

  var productData = null;
  var localizedProductData = null;
  var sourceOptions = [];
  var sourceMedia = {};
  var autoplayTimer = null;
  var lastColor = null;

  /* ---------- données produit ---------- */
  function loadProductData() {
    var host = document.querySelector('product-info[data-ciao-handle]');
    if (!host) return Promise.resolve(null);

    // Shopify publie l'URL française, même si le handle est traduit.
    var frenchLink = document.querySelector('link[hreflang="fr"], link[hreflang="fr-CA"]');
    var sourceUrl = new URL(frenchLink ? frenchLink.href : '/products/' + host.dataset.ciaoHandle, location.origin);
    var localizedUrl = new URL(host.dataset.url || location.pathname, location.origin);
    [sourceUrl, localizedUrl].forEach(function (url) {
      url.pathname = url.pathname.replace(/\/$/, '') + '.js';
      url.search = '';
      url.hash = '';
    });

    function readProduct(url) {
      return fetch(url.href)
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          return data && String(data.id) === host.dataset.productId ? data : null;
        })
        .catch(function () { return null; });
    }

    var sourceRequest = readProduct(sourceUrl);
    var localizedRequest = sourceUrl.href === localizedUrl.href ? sourceRequest : readProduct(localizedUrl);
    return Promise.all([sourceRequest, localizedRequest]).then(function (data) {
      productData = data[0];
      localizedProductData = data[1];
      sourceOptions = [];
      sourceMedia = {};
      if (!productData) return null;

      (productData.media || []).forEach(function (media) { sourceMedia[String(media.id)] = media; });
      var variantsById = {};
      (productData.variants || []).forEach(function (variant) { variantsById[String(variant.id)] = variant; });
      // Les IDs ne changent pas avec la langue. Aucune traduction de
      // couleur à deviner : « blue » peut désigner « whale », par exemple.
      ((localizedProductData || productData).variants || []).forEach(function (variant) {
        var source = variantsById[String(variant.id)];
        if (!source) return;
        (variant.options || []).forEach(function (value, index) {
          if (!sourceOptions[index]) sourceOptions[index] = Object.create(null);
          sourceOptions[index][norm(value)] = norm(source.options[index]);
        });
      });
      return productData;
    });
  }

  function sourceOption(value, index) {
    var key = norm(value);
    return (sourceOptions[index] && sourceOptions[index][key]) || versFrancais(key);
  }

  // Le texte affiché peut être traduit. Le filtre et le tri lisent
  // exclusivement le média français correspondant au même ID.
  function sourceAlt(item) {
    var media = sourceMedia[mediaIdOf(item)];
    if (media) return norm(media.alt);
    if (/^fr(?:-|$)/i.test(document.documentElement.lang || 'fr')) {
      var img = item.querySelector('img');
      return norm(img && img.alt);
    }
    return '';
  }

  function colorOptionIndex() {
    if (!productData) return -1;
    var names = (productData.options || []).map(function (o) {
      return (typeof o === 'string' ? o : o.name || '').toLowerCase();
    });
    for (var i = 0; i < names.length; i++) {
      if (names[i].indexOf('couleur') > -1 || /colou?r/.test(names[i])) return i;
    }
    return -1;
  }

  /* ---------- correspondance manuelle facultative ---------- */
  var tableCouleurs = null;

  function chargerTableCouleurs() {
    if (tableCouleurs) return tableCouleurs;
    tableCouleurs = {};
    var hote = document.querySelector('product-info[data-ciao-couleurs]');
    var brut = hote ? hote.getAttribute('data-ciao-couleurs') : '';
    if (!brut) return tableCouleurs;

    brut.split('|').forEach(function (ligne) {
      var morceaux = ligne.split(':');
      if (morceaux.length < 2) return;
      var gauche = morceaux[0].trim().toLowerCase();
      var droite = morceaux.slice(1).join(':').trim().toLowerCase();
      if (gauche && droite) tableCouleurs[gauche] = droite;
    });
    return tableCouleurs;
  }

  function versFrancais(valeur) {
    if (!valeur) return valeur;
    var table = chargerTableCouleurs();
    var cle = String(valeur).trim().toLowerCase();
    return table[cle] || cle;
  }

  function currentColor() {
    return versFrancais(couleurChoisie());
  }

  function couleurChoisie() {
    var idx = colorOptionIndex();
    var host = document.querySelector('product-info[data-ciao-handle]');
    if (!host) return null;
    // Le contrôle coché est à jour dès le clic; le champ caché de Dawn
    // ne reçoit le nouvel ID qu'après la réponse réseau.
    var controls = host.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select');
    for (var i = 0; i < controls.length; i++) {
      if (/couleur|colou?r/i.test(controls[i].name || '')) {
        return sourceOption(controls[i].value, idx);
      }
    }
    var variant = varianteChoisie();
    return idx > -1 && variant ? norm(variant.options[idx]) : null;
  }

  /* ---------- méthode B : blocs de médias par couleur ---------- */
  function mediaGroups() {
    var idx = colorOptionIndex();
    if (!productData || idx < 0) return null;

    var start = {};
    (productData.variants || []).forEach(function (v) {
      var color = versFrancais(v.options[idx]);
      var fm = v.featured_media;
      if (!fm || !color) return;
      if (start[color] === undefined || fm.position < start[color]) start[color] = fm.position;
    });

    var list = Object.keys(start).map(function (c) { return { color: c, start: start[c] }; });
    if (list.length < 2) return null; // il faut au moins deux blocs pour délimiter
    list.sort(function (a, b) { return a.start - b.start; });

    var total = (productData.media || []).length;
    list.forEach(function (g, i) {
      g.end = i + 1 < list.length ? list[i + 1].start - 1 : total;
    });

    var byColor = {};
    list.forEach(function (g) { byColor[g.color] = g; });

    var posById = {};
    (productData.media || []).forEach(function (m) { posById[m.id] = m.position; });

    return { byColor: byColor, posById: posById };
  }

  function mediaIdOf(item) {
    var raw = item.dataset.mediaId || '';
    var parts = raw.split('-');
    return parts[parts.length - 1];
  }

  /* ---------- filtrage ---------- */
  // Médias d'une couleur, ou null si aucune méthode ne s'applique.
  function itemsPourCouleur(items, color) {
    // Méthode A : texte alternatif
    var altMatched = items.filter(function (item) {
      return sourceAlt(item).indexOf(color) > -1;
    });
    if (altMatched.length) return altMatched;

    // Méthode B : blocs de médias
    var groups = mediaGroups();
    var group = groups && groups.byColor[color];
    if (group) {
      var byPosition = items.filter(function (item) {
        var pos = groups.posById[mediaIdOf(item)];
        return pos !== undefined && pos >= group.start && pos <= group.end;
      });
      if (byPosition.length) return byPosition;
    }
    return null;
  }

  function applyColorFilter(gallery) {
    if (!FILTRER_PAR_COULEUR) return;

    var color = currentColor();
    var items = [].slice.call(gallery.querySelectorAll('.product__media-item'));
    if (!color || !items.length) return;

    // Aucune méthode applicable : on montre tout.
    var matched = itemsPourCouleur(items, color) || items;

    items.forEach(function (item) {
      var doitEtreCache = matched.indexOf(item) === -1;
      if (item.hidden !== doitEtreCache) item.hidden = doitEtreCache;
    });

    // Le retour au début ne se fait qu'au vrai changement de couleur,
    // jamais pendant que la personne fait défiler la rangée.
    if (color !== lastColor) {
      lastColor = color;
      resetScroll(gallery);
    }
  }

  // Retour à la première photo, instantané. La classe vmr-instantane
  // coupe l'animation et l'aimantation le temps du saut (styles dans
  // variant-media-row.css).
  //
  // Une seule minuterie fait autorité pour son retrait (instantaneJusqua
  // / instantaneTimer, juste en dessous), et un appel ne peut jamais
  // raccourcir une fenêtre déjà en cours, seulement l'allonger. Avant,
  // chaque appel retirait la classe deux frames plus tard, sans savoir
  // qu'un appel précédent voulait la garder plus longtemps — ça coupait
  // le verrou de couleur (2,5 s, posé au clic) en dessous de lui, juste
  // avant que le thème (media-gallery.js, natif Dawn) fasse défiler la
  // rangée de son côté quand sa propre requête finissait par arriver :
  // la rangée n'était alors plus protégée et on la voyait glisser vers
  // cette photo pendant une fraction de seconde.
  var instantaneTimer = null;
  var instantaneJusqua = 0;

  function resetScroll(gallery) {
    var rail = gallery.querySelector('.product__media-list');
    if (!rail) return;
    remettreAuDebut(rail);
  }

  function remettreAuDebut(rail, dureeMs) {
    rail.classList.add('vmr-instantane');
    rail.scrollLeft = 0;

    var duree = dureeMs || 50;
    var cible = Date.now() + duree;
    if (cible <= instantaneJusqua) return;

    instantaneJusqua = cible;
    clearTimeout(instantaneTimer);
    instantaneTimer = setTimeout(function () {
      rail.classList.remove('vmr-instantane');
      instantaneJusqua = 0;
    }, duree);
  }

  /* ---------- la vidéo passe en deuxième position ---------- */
  function videoSecond(gallery) {
    var rail = gallery.querySelector('.product__media-list');
    if (!rail) return;

    var visible = [].filter.call(rail.children, function (c) { return !c.hidden; });
    if (visible.length < 2) return;

    var videoCell = null;
    visible.forEach(function (c) {
      if (!videoCell && c.querySelector('video, deferred-media, .media-type-video, .media-type-external_video')) {
        videoCell = c;
      }
    });
    if (!videoCell) return;

    var firstPhoto = null;
    visible.forEach(function (c) { if (!firstPhoto && c !== videoCell) firstPhoto = c; });
    if (!firstPhoto) return;

    // Sur téléphone, option pour placer la vidéo en tête : c'est la
    // seule façon qu'elle joue dès l'ouverture, puisqu'une vidéo hors
    // écran est mise en pause par le navigateur.
    // Insérer une case en tête décale tout le contenu vers la droite,
    // et le navigateur conserve la position de défilement : la case
    // qu'on vient de mettre en premier se retrouve hors champ. On
    // ramène donc la rangée au début après chaque déplacement.
    var surMobile = window.matchMedia('(max-width: 989px)').matches;
    if (VIDEO_EN_PREMIER_SUR_MOBILE && surMobile) {
      if (visible[0] !== videoCell) {
        rail.insertBefore(videoCell, visible[0]);
        rail.scrollLeft = 0;
      }
      return;
    }

    if (visible.indexOf(videoCell) === visible.indexOf(firstPhoto) + 1) return;
    rail.insertBefore(videoCell, firstPhoto.nextSibling);
    rail.scrollLeft = 0;
  }

  /* ---------- vidéos : lecture automatique en boucle ----------
     Le thème charge ses vidéos seulement au clic, et il met tous les
     médias en pause à plusieurs moments, entre autres à chaque
     changement de variante. On charge donc les vidéos nous-mêmes et
     on les relance dès qu'elles sont mises en pause. */

  // L'image d'aperçu reste en permanence derrière la vidéo. La vidéo
  // remplit sa case et la recouvre entièrement quand elle s'affiche.
  // S'il lui manque quoi que ce soit, on voit la photo plutôt qu'une
  // case blanche. Cette fonction ne sert donc plus qu'à réparer un
  // masquage laissé par une version précédente du script.
  function montrerApercu(cell) {
    if (!cell) return;
    cell.querySelectorAll('modal-opener, .deferred-media__poster').forEach(function (el) {
      if (el.style.display === 'none') el.style.removeProperty('display');
    });
  }

  // Une vidéo hors champ n'a pas à jouer : les navigateurs mobiles la
  // mettent en pause d'office pour économiser la batterie, et insister
  // ne sert qu'à se battre contre eux.
  function celluleVisible(cell) {
    if (!cell || cell.hidden) return false;
    var rail = cell.parentElement;
    if (!rail) return false;
    var rc = cell.getBoundingClientRect();
    var rr = rail.getBoundingClientRect();
    if (!rc.width || !rr.width) return false;
    var chevauchement = Math.min(rc.right, rr.right) - Math.max(rc.left, rr.left);
    return chevauchement > rc.width * 0.35;
  }

  // Lecture pilotée par la visibilité dans la rangée. Deux mécanismes
  // en parallèle, parce qu'aucun n'est fiable seul sur mobile :
  // l'observateur de visibilité, et le défilement de la rangée.
  function observerVideos(gallery) {
    var rail = gallery.querySelector('.product__media-list');
    if (!rail) return;

    if (window.IntersectionObserver) {
      if (!gallery.__vmrObs) {
        gallery.__vmrObs = new IntersectionObserver(function (entrees) {
          entrees.forEach(function (entree) {
            var v = entree.target.querySelector('video');
            if (!v) return;
            // On relance en entrant dans le champ, mais on ne met jamais
            // en pause en sortant : le navigateur s'en charge lui-même
            // s'il juge utile d'économiser la batterie.
            if (entree.isIntersecting) v.play().catch(function () {});
          });
        }, { root: rail, threshold: 0.35 });
      }

      gallery.querySelectorAll('.product__media-item[data-vmr-video]').forEach(function (cell) {
        if (cell.dataset.vmrObserve) return;
        cell.dataset.vmrObserve = '1';
        gallery.__vmrObs.observe(cell);
      });
    }

    // Filet : à chaque arrêt du défilement, on remet chaque vidéo dans
    // l'état qui correspond à sa position. Couvre les cas où
    // l'observateur ne se déclenche pas, fréquents sur téléphone.
    if (!rail.dataset.vmrScrollVideo) {
      rail.dataset.vmrScrollVideo = '1';
      var attente;
      rail.addEventListener('scroll', function () {
        clearTimeout(attente);
        attente = setTimeout(function () {
          gallery.querySelectorAll('video').forEach(prepareVideo);
        }, 120);
      }, { passive: true });
    }
  }

  function prepareVideo(v) {
    var cell = v.closest('.product__media-item');

    // Ces attributs sont ce qui autorise la lecture automatique sans
    // geste de l'utilisateur, sur ordinateur comme sur téléphone.
    v.muted = true;
    v.setAttribute('muted', '');
    v.loop = true;
    v.setAttribute('loop', '');
    v.controls = false;
    v.removeAttribute('controls');
    v.setAttribute('playsinline', '');
    v.setAttribute('preload', 'auto');

    // On ne met en pause que les vidéos d'une autre couleur, donc
    // réellement retirées de la rangée. Une vidéo simplement hors champ
    // a le droit de jouer : c'est au navigateur de décider s'il
    // l'économise, pas à nous de l'en empêcher.
    if (cell && cell.hidden) {
      if (!v.paused) v.pause();
      return;
    }

    if (!v.dataset.vmrAuto) {
      v.dataset.vmrAuto = '1';

      v.addEventListener('pause', function () {
        var c = v.closest('.product__media-item');
        if (!c || c.hidden || document.hidden) return;
        var maintenant = Date.now();
        if (maintenant - (v.__vmrDernier || 0) < 400) return; // anti-boucle
        v.__vmrDernier = maintenant;
        setTimeout(function () { v.play().catch(function () {}); }, 80);
      });

    }

    if (v.paused) v.play().catch(function () {});

    montrerApercu(cell);
  }

  // iOS et Android n'acceptent la lecture sans geste de l'utilisateur
  // que si ces attributs sont là AVANT le chargement de la vidéo. Le
  // thème garde sa vidéo dans un gabarit : on la prépare dedans, avant
  // qu'elle ne soit sortie et mise dans la page.
  function preparerGabarit(dm) {
    var gabarit = dm.querySelector('template');
    if (!gabarit || !gabarit.content) return;
    var v = gabarit.content.querySelector('video');
    if (!v) return;
    v.setAttribute('muted', '');
    v.muted = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.setAttribute('autoplay', '');
    v.setAttribute('loop', '');
    v.setAttribute('preload', 'auto');
    v.removeAttribute('controls');
  }

  function autoplayVideos(root) {
    root.querySelectorAll('deferred-media').forEach(function (dm) {
      var cell = dm.closest('.product__media-item');
      if (cell && cell.hidden) return;
      if (dm.getAttribute('loaded')) return;

      preparerGabarit(dm);

      if (typeof dm.loadContent === 'function') {
        try { dm.loadContent(false); } catch (e) {}
      } else {
        // Repli si le composant du thème n'est pas encore actif :
        // on sort la vidéo de son gabarit nous-mêmes.
        var gabarit = dm.querySelector('template');
        var contenu = gabarit && gabarit.content.firstElementChild;
        if (contenu) {
          dm.appendChild(contenu.cloneNode(true));
          dm.setAttribute('loaded', 'true');
        }
      }
    });

    root.querySelectorAll('video').forEach(prepareVideo);


    // Surveillance : la vidéo peut arriver en retard, et le thème peut
    // la mettre en pause plus tard.
    clearInterval(autoplayTimer);
    var tours = 0;
    autoplayTimer = setInterval(function () {
      tours++;
      var videos = root.querySelectorAll('video');
      if (videos.length) {
        videos.forEach(prepareVideo);

      }
      if (tours > 20) clearInterval(autoplayTimer);
    }, 700);
  }

  /* ---------- marquage des cases vidéo ----------
     LE SCRIPT NE TOUCHE PLUS À LA MISE EN PAGE. Tout le cadrage est
     fait par variant-media-row.css. Les styles en ligne que le script
     posait auparavant l'emportaient sur le fichier CSS et, quand ils
     n'atteignaient pas tous les éléments, laissaient la vidéo à ses
     proportions d'origine. Ici on ne pose plus qu'un marqueur, dont le
     CSS se sert pour rendre les cases vidéo non cliquables. On nettoie
     aussi les styles laissés par les versions précédentes. */
  function markVideoCells(gallery) {
    gallery.querySelectorAll('.product__media-item').forEach(function (item) {
      if (item.querySelector('video, deferred-media, iframe, .media-type-video, .media-type-external_video')) {
        item.setAttribute('data-vmr-video', '1');
      } else {
        item.removeAttribute('data-vmr-video');
      }

      // Ménage : styles en ligne laissés par une version antérieure.
      if (item.hasAttribute('data-vmr-nettoye')) return;
      item.setAttribute('data-vmr-nettoye', '1');
      item.removeAttribute('style');
      item.querySelectorAll('[data-vmr]').forEach(function (el) {
        el.removeAttribute('style');
        el.removeAttribute('data-vmr');
      });
    });
  }

  /* ---------- aucune case vide dans la rangée ----------
     Une case dont le média ne charge pas s'afficherait en blanc entre
     deux photos. On la retire de la rangée. */
  function hideEmptyCells(gallery) {
    gallery.querySelectorAll('.product__media-item').forEach(function (cell) {
      if (cell.hidden) return;
      var media = cell.querySelector('img, video, iframe, model-viewer');
      var vide = !media;
      if (media && media.tagName === 'IMG' && !media.getAttribute('src') && !media.getAttribute('srcset')) {
        vide = true;
      }
      if (vide) cell.hidden = true;
    });
  }

  /* ---------- pas d'espace vide au bout de la rangée ----------
     Si la couleur choisie a peu de médias, leur largeur totale peut
     ne pas remplir la rangée sur un grand écran. Les cases s'élargis-
     sent alors pour occuper toute la place. */
  function fitCells(gallery) {
    var rail = gallery.querySelector('.product__media-list');
    if (!rail) return;

    var visibles = [].filter.call(rail.children, function (c) { return !c.hidden; }).length;
    if (!visibles) return;

    // On repart de la valeur du CSS avant de décider.
    gallery.style.removeProperty('--vmr-cell');
    var base = parseFloat(getComputedStyle(gallery).getPropertyValue('--vmr-cell')) || 50;

    if (visibles * base < 100) {
      gallery.style.setProperty('--vmr-cell', (100 / visibles) + '%');
    }
  }

  /* ---------- netteté et chargement des images ----------
     Le thème demande à Shopify des images calculées pour sa propre
     mise en page, plus étroites que nos cases. On lui indique la
     largeur réelle, et on charge tout de suite les premières cases
     pour éviter une case blanche le temps du chargement. */
  function tuneImages(gallery) {
    var visibles = [].filter.call(
      gallery.querySelectorAll('.product__media-item'),
      function (c) { return !c.hidden; }
    );

    visibles.forEach(function (cell, index) {
      var largeur = Math.round(cell.getBoundingClientRect().width);
      cell.querySelectorAll('img').forEach(function (img) {
        if (largeur > 0) img.setAttribute('sizes', largeur + 'px');
        if (index < 4) img.setAttribute('loading', 'eager');
      });
    });
  }

  /* ---------- ordre des photos par numéro ----------
     Une photo dont le texte alternatif contient « couleur + numéro »
     (« beige 1 », mais aussi « beige 2 doudoune isolée pour homme… »
     avec du texte SEO après le numéro) passe avant les autres, dans
     l'ordre croissant. Les photos sans numéro suivent, dans l'ordre de
     l'admin Shopify. Le tri s'applique à toute la rangée : comme
     seules les photos de la couleur choisie sont visibles, l'effet
     se voit couleur par couleur. */

  // Couleurs du produit, une seule fois par tri plutôt qu'à chaque
  // cellule : la liste vient des variantes plutôt que de
  // product.options, dont la forme (tableau de chaînes ou d'objets)
  // varie selon les produits.
  function couleursConnues() {
    var idx = colorOptionIndex();
    if (idx < 0 || !productData) return [];
    var vues = {};
    (productData.variants || []).forEach(function (v) {
      var c = versFrancais((v.options || [])[idx]);
      if (c) vues[c] = true;
    });
    return Object.keys(vues);
  }

  function couleurDeCellule(cell, couleurs) {
    var alt = sourceAlt(cell);
    for (var i = 0; i < couleurs.length; i++) {
      if (alt.indexOf(couleurs[i]) > -1) return couleurs[i];
    }
    return null;
  }

  function numeroDeCellule(cell, couleurs) {
    var alt = sourceAlt(cell);

    // Numéro juste après le nom de la couleur, même suivi d'un texte
    // descriptif (« gris 2 doudoune isolée pour homme… » → 2). Avant,
    // on exigeait que le chiffre soit tout à la fin du texte
    // alternatif, ce qui ratait les textes « couleur + numéro +
    // description SEO ».
    var couleur = couleurDeCellule(cell, couleurs || []);
    if (couleur) {
      var echappee = couleur.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var trouveApresCouleur = alt.match(new RegExp(echappee + '\\s*(\\d+)'));
      if (trouveApresCouleur) return parseInt(trouveApresCouleur[1], 10);
    }

    // Repli : chiffre tout à la fin (l'ancienne convention, ou une
    // photo dont l'alt ne contient aucune des couleurs du produit).
    var trouve = alt.match(/(\d+)\s*$/);
    return trouve ? parseInt(trouve[1], 10) : 0;
  }

  function trierParNumero(gallery) {
    var rail = gallery.querySelector('.product__media-list');
    if (!rail) return;

    var cells = [].slice.call(rail.children);
    if (cells.length < 2) return;

    var couleurs = couleursConnues();

    // La photo vedette de la variante choisie (mise en tête par
    // mettreVedetteEnTete, juste avant refresh()) ne doit jamais être
    // déplacée par ce tri, même si son numéro n'est pas le plus petit.
    // Sinon, dès que refresh() tourne, le tri numérique la repousse
    // derrière une autre photo de la même couleur : elle apparaît une
    // fraction de seconde, puis se fait remplacer sous les yeux.
    var vedette = varianteChoisie();
    var celluleVedette = vedette && vedette.featured_media
      ? celluleParMediaId(rail, vedette.featured_media.id)
      : null;

    var aTrier = celluleVedette ? cells.filter(function (c) { return c !== celluleVedette; }) : cells;
    if (aTrier.length < 2) return;

    var rangs = [];
    var numerotees = 0;
    aTrier.forEach(function (cell, position) {
      var numero = numeroDeCellule(cell, couleurs);
      if (numero > 0) numerotees++;
      rangs.push({ cell: cell, numero: numero > 0 ? numero : 99999, position: position });
    });
    if (!numerotees) return;

    rangs.sort(function (a, b) {
      if (a.numero !== b.numero) return a.numero - b.numero;
      return a.position - b.position;
    });

    var ordreVoulu = celluleVedette ? [celluleVedette] : [];
    rangs.forEach(function (r) { ordreVoulu.push(r.cell); });

    var dejaBon = true;
    ordreVoulu.forEach(function (cell, i) { if (cells[i] !== cell) dejaBon = false; });
    if (dejaBon) return;

    ordreVoulu.forEach(function (cell) { rail.appendChild(cell); });
  }

  /* ---------- photo de la variante en tête, tout de suite ----------
     Quand le serveur répond, Dawn (product-info.js) remet en tête la
     photo associée à la variante. Sur réseau mobile, ça arrive 1 à 3
     secondes après le toucher et l'image changeait sous les yeux. On
     fait ce déplacement nous-mêmes dès le toucher : le thème n'a plus
     rien à changer en tête quand il reçoit sa réponse. */
  function norm(texte) {
    return String(texte || '').trim().toLowerCase();
  }

  // Compare les options sélectionnées à leurs valeurs françaises pour
  // connaître la nouvelle variante avant la réponse AJAX de Dawn.
  function varianteChoisie() {
    if (!productData) return null;
    var host = document.querySelector('product-info[data-ciao-handle]');
    if (!host) return null;
    var groups = host.querySelectorAll('variant-selects .product-form__input');
    var selected = [];
    groups.forEach(function (group, index) {
      var control = group.querySelector('input[type="radio"]:checked, select');
      if (control) selected.push(sourceOption(control.value, index));
    });
    if (selected.length === (productData.options || []).length && selected.length) {
      return (productData.variants || []).find(function (variant) {
        return variant.options.every(function (value, index) { return norm(value) === selected[index]; });
      }) || null;
    }
    var field = host.querySelector('form[action*="/cart/add"] [name="id"]');
    return field ? (productData.variants || []).find(function (variant) {
      return String(variant.id) === String(field.value);
    }) || null : null;
  }

  function celluleParMediaId(rail, id) {
    var cible = null;
    [].forEach.call(rail.children, function (li) {
      if (!cible && li.dataset && li.dataset.mediaId && mediaIdOf(li) === String(id)) cible = li;
    });
    return cible;
  }

  function mettreVedetteEnTete(gallery) {
    var v = varianteChoisie();
    if (!v || !v.featured_media) return;
    var rail = gallery.querySelector('.product__media-list');
    if (!rail) return;
    var cible = celluleParMediaId(rail, v.featured_media.id);
    if (cible && rail.firstElementChild !== cible) rail.insertBefore(cible, rail.firstElementChild);
  }

  /* ---------- préchargement des autres couleurs ----------
     Les photos des couleurs non choisies sont cachées et en chargement
     différé : le téléphone ne les téléchargeait qu'au changement de
     couleur. Une seconde après l'ouverture de la page, on charge en
     arrière-plan les PRECHARGER_PAR_COULEUR premières photos de chaque
     couleur, directement à la largeur réelle des cases (sinon le
     navigateur les retélécharge plus grandes à l'affichage). */
  var PRECHARGER_PAR_COULEUR = 2;
  var prechargementPrevu = false;

  function planifierPrechargement() {
    if (prechargementPrevu) return;
    prechargementPrevu = true;
    setTimeout(function () {
      var gallery = document.querySelector('media-gallery');
      if (gallery) etape('prechargement', function () { prechargerCouleurs(gallery); });
    }, 1000);
  }

  function prechargerCouleurs(gallery) {
    if (!FILTRER_PAR_COULEUR) return;
    var fs = trouverFieldsetCouleur();
    if (!fs) return;

    var items = [].slice.call(gallery.querySelectorAll('.product__media-item'));
    var modele = null;
    items.forEach(function (c) { if (!modele && !c.hidden) modele = c; });
    var largeur = modele ? Math.round(modele.getBoundingClientRect().width) : 0;
    if (!largeur) return;

    var aPrecharger = [];

    // Photo associée à chaque variante : c'est elle qui passe en tête.
    var rail = gallery.querySelector('.product__media-list');
    if (rail && productData) {
      (productData.variants || []).forEach(function (v) {
        if (!v.featured_media) return;
        var cell = celluleParMediaId(rail, v.featured_media.id);
        if (cell && aPrecharger.indexOf(cell) === -1) aPrecharger.push(cell);
      });
    }

    // Premières photos de chaque couleur. Les noms viennent de
    // productData (toujours en français), pas des pastilles du DOM
    // (traduites sur une boutique multilingue), pour rester cohérent
    // avec le texte alternatif des photos.
    couleursConnues().forEach(function (couleur) {
      var siens = itemsPourCouleur(items, couleur);
      if (!siens) return;
      siens.slice(0, PRECHARGER_PAR_COULEUR).forEach(function (cell) {
        if (aPrecharger.indexOf(cell) === -1) aPrecharger.push(cell);
      });
    });

    aPrecharger.forEach(function (cell) {
      cell.querySelectorAll('img').forEach(function (img) {
        img.setAttribute('sizes', largeur + 'px');
        img.setAttribute('loading', 'eager');
      });
    });
  }

  /* ---------- pastilles de couleur sous les photos (téléphone) ----------
     Le thème regroupe couleur et taille dans un même bloc, et ce bloc
     ne peut pas être démonté sans casser le changement de variante.
     On affiche donc une copie des pastilles sous les photos : cliquer
     sur une copie actionne la vraie pastille, restée en place. */
  // Recherche TOUJOURS faite au moment où on en a besoin. Le thème
  // reconstruit son sélecteur de variante à chaque changement, donc
  // toute référence gardée en mémoire pointe vite vers un élément
  // retiré de la page, et les clics ne font plus rien.
  function trouverFieldsetCouleur() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return null;
    var trouve = null;
    vs.querySelectorAll('fieldset').forEach(function (fs) {
      if (trouve) return;
      var legende = (fs.querySelector('legend') || {}).textContent || '';
      var input = fs.querySelector('input[type="radio"]');
      var nom = input ? input.name : '';
      if (/couleur|colou?r/i.test(legende) || /couleur|colou?r/i.test(nom)) trouve = fs;
    });
    return trouve;
  }

  function radioParValeur(fieldset, valeur) {
    if (!fieldset) return null;
    var cible = null;
    var cherchee = String(valeur || '').trim().toLowerCase();
    fieldset.querySelectorAll('input[type="radio"]').forEach(function (r) {
      if (cible) return;
      if (String(r.value || '').trim().toLowerCase() === cherchee) cible = r;
    });
    return cible;
  }

  function signatureCouleurs(fieldset) {
    if (!fieldset) return '';
    var valeurs = [];
    fieldset.querySelectorAll('input[type="radio"]').forEach(function (r) {
      valeurs.push(r.value);
    });
    return valeurs.join('|');
  }

  function setupMobileColors() {
    var host = document.querySelector('.product__media-wrapper');
    var colorFs = trouverFieldsetCouleur();
    if (!host || !colorFs) return; // couleur en menu déroulant : rien à copier

    colorFs.setAttribute('data-vmr-couleur', '1');

    var copieExistante = document.querySelector('.vmr-mobile-colors');
    var signature = signatureCouleurs(colorFs);

    // Les couleurs n'ont pas changé : on garde la copie en place plutôt
    // que de la reconstruire, ce qui la retirerait sous le doigt de la
    // personne au moment même où elle appuie dessus.
    if (copieExistante && copieExistante.getAttribute('data-vmr-signature') === signature) return;
    if (copieExistante) copieExistante.remove();

    var boite = document.createElement('div');
    boite.className = 'vmr-mobile-colors';
    boite.setAttribute('data-vmr-signature', signature);

    var copie = colorFs.cloneNode(true);
    copie.removeAttribute('data-vmr-couleur');

    copie.querySelectorAll('input[type="radio"]').forEach(function (input, i) {
      var ancienId = input.id;
      var nouvelId = 'vmr-couleur-' + i;
      var etiquette = ancienId ? copie.querySelector('label[for="' + ancienId + '"]') : null;

      // La copie ne doit JAMAIS contenir de bouton coché : ciao-swatch-accent.js
      // lirait sa couleur (l'ancienne) au lieu de celle du vrai sélecteur.
      // L'état actif est simulé par la classe vmr-actif sur l'étiquette.
      input.name = 'vmr-couleur';
      input.id = nouvelId;
      input.checked = false;
      input.removeAttribute('checked');
      input.tabIndex = -1;
      if (!etiquette) return;

      etiquette.setAttribute('for', nouvelId);
      etiquette.setAttribute('data-vmr-valeur', input.value);
      etiquette.addEventListener('click', function (e) {
        e.preventDefault();                          // ne coche pas la copie
        var valeur = etiquette.getAttribute('data-vmr-valeur');
        marquerCopieActive(copie, valeur);
        var fs = trouverFieldsetCouleur();          // recherche fraîche
        var vraie = radioParValeur(fs, valeur);
        if (vraie && !vraie.checked) vraie.click();
      });
    });

    boite.appendChild(copie);
    host.insertAdjacentElement('afterend', boite);
  }

  // Pose la classe vmr-actif sur l'étiquette de la couleur choisie et
  // s'assure qu'aucun bouton de la copie n'est coché.
  function marquerCopieActive(copie, valeur) {
    var cherchee = String(valeur || '').trim().toLowerCase();
    copie.querySelectorAll('input[type="radio"]').forEach(function (r) {
      if (r.checked) r.checked = false;
      var lab = copie.querySelector('label[for="' + r.id + '"]');
      if (!lab) return;
      if (String(r.value || '').trim().toLowerCase() === cherchee) {
        lab.classList.add('vmr-actif');
      } else {
        lab.classList.remove('vmr-actif');
      }
    });
  }

  // Remet la copie en accord avec la couleur réellement choisie.
  function syncMobileColors() {
    var copie = document.querySelector('.vmr-mobile-colors');
    var colorFs = trouverFieldsetCouleur();
    if (!copie || !colorFs) return;

    var choisie = colorFs.querySelector('input[type="radio"]:checked');
    marquerCopieActive(copie, choisie ? choisie.value : '');

    var legendeSource = colorFs.querySelector('legend');
    var legendeCopie = copie.querySelector('legend');
    if (legendeSource && legendeCopie && legendeCopie.innerHTML !== legendeSource.innerHTML) {
      legendeCopie.innerHTML = legendeSource.innerHTML;
    }
  }

  /* ---------- glissement à la souris ----------
     Sur ordinateur, la rangée se tire à la main comme sur un écran
     tactile. Le tactile, lui, est laissé au navigateur : il le fait
     déjà très bien tout seul. */
  function enableDrag(gallery) {
    // Réglage « Glisser les photos à la souris » de la section :
    // main-product.liquid pose data-vmr-glisser quand la case est cochée.
    if (!gallery.closest('[data-vmr-glisser]')) return;
    var rail = gallery.querySelector('.product__media-list');
    if (!rail || rail.dataset.vmrDrag) return;
    rail.dataset.vmrDrag = '1';

    var actif = false;
    var departX = 0;
    var departScroll = 0;
    var distance = 0;

    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // défilement natif du doigt
      if (e.button !== 0) return;            // clic gauche seulement
      actif = true;
      distance = 0;
      departX = e.clientX;
      departScroll = rail.scrollLeft;
      rail.classList.add('vmr-drag');
    });

    window.addEventListener('pointermove', function (e) {
      if (!actif) return;
      var dx = e.clientX - departX;
      if (Math.abs(dx) > distance) distance = Math.abs(dx);
      rail.scrollLeft = departScroll - dx;
    });

    function relacher() {
      if (!actif) return;
      actif = false;
      rail.classList.remove('vmr-drag');
      if (gallery.__vmrUpdateArrows) gallery.__vmrUpdateArrows();
    }
    window.addEventListener('pointerup', relacher);
    window.addEventListener('pointercancel', relacher);
    window.addEventListener('blur', relacher);

    // Un glissement ne doit pas ouvrir la visionneuse au relâchement.
    rail.addEventListener('click', function (e) {
      if (distance > 5) {
        e.preventDefault();
        e.stopPropagation();
        distance = 0;
      }
    }, true);

    // Pas de « fantôme » d'image traînée par le navigateur.
    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ---------- flèches ---------- */
  function setupArrows(gallery) {
    var rail = gallery.querySelector('.product__media-list');
    if (!rail) return;

    if (gallery.__vmrUpdateArrows) { gallery.__vmrUpdateArrows(); return; }

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'vmr-arrow is-prev';
    prev.setAttribute('aria-label', 'Médias précédents');
    prev.innerHTML = '&#8592;';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'vmr-arrow is-next';
    next.setAttribute('aria-label', 'Médias suivants');
    next.innerHTML = '&#8594;';

    function step() {
      var visible = rail.querySelector('.product__media-item:not([hidden])');
      return visible ? Math.round(visible.getBoundingClientRect().width) : 400;
    }

    // Les flèches ne sont jamais désactivées : elles sont seulement
    // atténuées quand il n'y a plus rien à faire défiler. Un bouton
    // désactivé à tort ne répondrait plus au clic.
    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.classList.toggle('is-off', rail.scrollLeft <= 2);
      next.classList.toggle('is-off', rail.scrollLeft >= max);
    }

    function go(direction) {
      var max = rail.scrollWidth - rail.clientWidth;
      var target = Math.max(0, Math.min(max, rail.scrollLeft + direction * step()));
      var depart = rail.scrollLeft;
      rail.scrollTo({ left: target, behavior: 'smooth' });
      // Repli si le défilement animé ne se produit pas.
      setTimeout(function () {
        if (Math.abs(rail.scrollLeft - depart) < 2 && Math.abs(target - depart) > 2) {
          rail.scrollLeft = target;
        }
        update();
      }, 350);
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    rail.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    window.addEventListener('load', update);

    gallery.appendChild(prev);
    gallery.appendChild(next);
    gallery.__vmrUpdateArrows = update;

    // Les images arrivent après coup : on remesure quelques fois.
    [300, 900, 2000].forEach(function (delay) { setTimeout(update, delay); });
    update();
  }

  /* ---------- mode diagnostic à l'écran ----------
     Ajouter ?vmrdebug=1 à l'adresse de la page affiche un encadré noir
     en bas de l'écran avec l'état réel des vidéos. Conçu pour le
     téléphone, où il n'y a pas de console. Sans le paramètre, ce code
     ne fait rien du tout. */
  function debugOverlay() {
    if (window.location.search.indexOf('vmrdebug=1') === -1) return;
    if (document.getElementById('vmr-debug')) return;

    var boite = document.createElement('div');
    boite.id = 'vmr-debug';
    boite.setAttribute('style', 'position:fixed;left:8px;right:8px;bottom:8px;z-index:99999;' +
      'background:rgba(0,0,0,.88);color:#fff;font:12px/1.45 monospace;padding:10px 12px;' +
      'border-radius:8px;white-space:pre-wrap;max-height:50vh;overflow:auto;pointer-events:none');
    document.body.appendChild(boite);

    setInterval(function () {
      var g = document.querySelector('media-gallery');
      var dms = g ? g.querySelectorAll('deferred-media') : [];
      var vs = g ? g.querySelectorAll('video') : [];
      var lignes = [];

      lignes.push('version ' + window.VMR_VERSION + '   passages ' + window.VMR_PASSAGES);
      lignes.push('erreur: ' + (window.VMR_ERREUR || 'aucune'));
      lignes.push('blocs video: ' + dms.length + '   balises video: ' + vs.length);

      [].forEach.call(dms, function (dm, i) {
        var cell = dm.closest('.product__media-item');
        lignes.push('bloc' + i +
          ' charge=' + (dm.getAttribute('loaded') || 'non') +
          ' fonction=' + (typeof dm.loadContent) +
          ' caseMasquee=' + (cell ? cell.hidden : '?') +
          ' aLecran=' + (cell ? celluleVisible(cell) : '?'));
      });

      [].forEach.call(vs, function (v, i) {
        lignes.push('video' + i +
          ' pause=' + v.paused +
          ' t=' + v.currentTime.toFixed(1) +
          ' image=' + v.videoWidth + 'x' + v.videoHeight +
          ' pret=' + v.readyState +
          ' err=' + (v.error ? v.error.code : '-') +
          ' muet=' + v.muted +
          ' inline=' + v.hasAttribute('playsinline'));
      });

      if (!vs.length && !dms.length) lignes.push('aucune video trouvee dans la galerie');
      boite.textContent = lignes.join('\n');
    }, 1000);
  }

  /* ---------- initialisation ----------
     Chaque étape est protégée : si l'une échoue, les suivantes
     s'exécutent quand même et l'erreur reste lisible dans
     window.VMR_ERREUR plutôt que de tout arrêter. */
  function etape(nom, fn) {
    try {
      fn();
    } catch (e) {
      window.VMR_ERREUR = nom + ' : ' + (e && e.message ? e.message : e);
      if (window.console) console.warn('[variant-media-row] ' + window.VMR_ERREUR);
    }
  }

  function refresh() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) {
      window.VMR_ERREUR = 'aucune galerie trouvée sur la page';
      return;
    }

    window.VMR_PASSAGES++;

    etape('fleches', function () { setupArrows(gallery); });
    etape('neutralisation saut taille', function () { neutraliserSautTaille(gallery); });
    etape('glissement', function () { enableDrag(gallery); });
    etape('filtre couleur', function () { applyColorFilter(gallery); });
    etape('tri par numero', function () { trierParNumero(gallery); });
    etape('cases vides', function () { hideEmptyCells(gallery); });
    etape('video en 2e', function () { videoSecond(gallery); });
    etape('largeur des cases', function () { fitCells(gallery); });
    etape('marquage video', function () { markVideoCells(gallery); });
    etape('images', function () { tuneImages(gallery); });
    etape('lecture video', function () { autoplayVideos(gallery); });
    etape('visibilite video', function () { observerVideos(gallery); });
    etape('couleurs mobile', function () { setupMobileColors(); syncMobileColors(); });
    planifierPrechargement();

    if (gallery.__vmrUpdateArrows) gallery.__vmrUpdateArrows();
  }

  function boot() {
    debugOverlay();
    loadProductData().then(refresh);

    // Changement de variante : Dawn met à jour le champ caché name="id",
    // puis va chercher en arrière-plan le prix/la galerie de la nouvelle
    // variante et met la page à jour un peu plus tard. On ne connaît pas
    // ce délai à l'avance, mais Dawn (product-info.js) publie l'événement
    // « variant-change » juste après avoir fini — c'est le bon moment pour
    // notre unique repassage. On garde un filet de sécurité à 1500 ms au
    // cas où cet événement ne se déclenche pas (ex. la variante appartient
    // à un autre produit et Dawn recharge toute la page autrement).
    //
    // Avant, on repassait à l'aveugle 4 fois (0/400/900/1600 ms) : chaque
    // repassage remesure la largeur des cases pour la photo (tuneImages)
    // et, tant que la mise en page n'était pas encore stable, ça faisait
    // retélécharger la photo à une taille différente une fois stabilisée —
    // le petit « pop » de chargement séparé que tu vois sur la photo de la
    // variante. Un seul repassage, déclenché au bon moment, l'évite.
    var filetSecurite;
    function planifierRepassage() {
      clearTimeout(filetSecurite);
      filetSecurite = setTimeout(refresh, 1500);
    }

    document.addEventListener('change', function (e) {
      if (e.target && (e.target.name === 'id' || /couleur|colou?r/i.test(e.target.name || ''))) {
        planifierRepassage();
      }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        clearTimeout(filetSecurite);
        refresh();
      });
    }

    var redim;
    window.addEventListener('resize', function () {
      var gallery = document.querySelector('media-gallery');
      if (!gallery) return;

      clearTimeout(redim);
      redim = setTimeout(function () {
        // Rotation du téléphone, passage ordinateur / mobile : l'ordre
        // des médias peut changer, donc on repasse tout.
        refresh();
      }, 200);
    });

    window.addEventListener('load', refresh);

    // Dernier recours sur téléphone : certains navigateurs refusent la
    // lecture tant que la personne n'a rien touché. Au premier contact
    // avec l'écran, quel qu'il soit, on relance les vidéos visibles.
    ['touchstart', 'pointerdown', 'scroll'].forEach(function (evenement) {
      window.addEventListener(evenement, function relancer() {
        ['touchstart', 'pointerdown', 'scroll'].forEach(function (e) {
          window.removeEventListener(e, relancer);
        });
        var gallery = document.querySelector('media-gallery');
        if (gallery) etape('relance video', function () { autoplayVideos(gallery); });
      }, { passive: true });
    });

    // Le thème reconstruit la galerie après un changement de couleur :
    // on réapplique tout dès que son contenu change. Le défilement n'est
    // plus remis à zéro que lors d'un vrai changement de couleur, donc
    // repasser ici ne dérange pas la navigation.
    var wrapper = document.querySelector('.product__media-wrapper');
    if (wrapper && window.MutationObserver) {
      var pending;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(refresh, 120);
      }).observe(wrapper, { childList: true, subtree: true });
    }

    // Le thème reconstruit aussi le sélecteur de variante après chaque
    // changement, ce qui efface la copie des pastilles. On la refait.
    var infos = document.querySelector('.product__info-wrapper');
    if (infos && window.MutationObserver) {
      var enAttente;
      new MutationObserver(function () {
        clearTimeout(enAttente);
        enAttente = setTimeout(function () {
          setupMobileColors();
          syncMobileColors();
        }, 150);
      }).observe(infos, { childList: true, subtree: true });
    }
  }

  /* ---------- page immobile au changement de variante ----------
     À chaque changement de variante, media-gallery.js (Dawn) fait
     défiler la page jusqu'en haut de la photo choisie dès qu'elle
     dépasse du haut de l'écran. Sur téléphone, les pastilles étant
     sous les photos, la page sautait à chaque touche.
     On note la hauteur de la page au moment du choix, puis on la
     remet en place si elle bouge dans les 3 secondes qui suivent (le
     thème attend la réponse du serveur avant de défiler). Le verrou
     saute dès que la personne touche l'écran ou la molette. */
  var verrou = { y: 0, jusqua: 0 };

  // Verrou de la rangée : après un changement de couleur, media-gallery.js
  // (Dawn) fait glisser la rangée vers la photo de la variante. On la
  // garde sur la première photo tant que la personne n'y touche pas.
  var verrouRangee = { jusqua: 0 };

  // Vrai seulement juste après un changement de taille (ou toute autre
  // option qui n'est pas la couleur) : la rangée ne doit pas bouger, la
  // personne reste sur la photo qu'elle regardait. Remis à false dès
  // qu'un vrai changement de couleur survient (voir installerVerrou).
  var tailleSeulement = false;

  // Le thème (media-gallery.js, natif Dawn) remet toujours la rangée sur
  // la photo vedette de la variante à chaque changement — couleur ET
  // taille confondues (son setActiveMedia(id, true) est appelé sans
  // distinction). Pour un changement de taille, on ne veut aucun de ces
  // effets : ni le déplacement de la photo en tête (prepend), ni le
  // retour de la rangée à sa position (scrollTo), qui ferait perdre la
  // photo que la personne était en train de regarder. On neutralise donc
  // entièrement l'appel dans ce cas précis, en gardant tout le reste du
  // comportement du thème intact pour un vrai changement de couleur.
  function neutraliserSautTaille(gallery) {
    if (!gallery || gallery.__vmrSetActiveMediaPatchee) return;
    gallery.__vmrSetActiveMediaPatchee = true;
    var original = gallery.setActiveMedia;
    if (typeof original !== 'function') return;
    gallery.setActiveMedia = function (mediaId, prepend) {
      if (tailleSeulement) return;
      return original.call(gallery, mediaId, prepend);
    };
  }

  function estSelecteurVariante(el) {
    if (!el || !el.closest) return false;
    return !!(el.closest('variant-selects') || el.closest('.vmr-mobile-colors'));
  }

  function poserVerrou() {
    verrou.y = window.pageYOffset;
    verrou.jusqua = Date.now() + 3000;
  }

  function installerVerrou() {
    if (window.VMR_VERROU_INSTALLE) return;
    window.VMR_VERROU_INSTALLE = true;

    // Empêche à la source tout scrollTo vertical pendant le verrou —
    // en particulier celui que media-gallery.js (thème Dawn) déclenche
    // pour remonter la page vers la photo choisie, en « smooth », dès
    // qu'elle dépasse du haut de l'écran (le cas typique : la personne a
    // descendu jusqu'aux tailles). Avant, on laissait ce défilement
    // partir puis on le corrigeait à chaque event scroll plus bas :
    // les deux se battaient image par image pendant toute la durée de
    // l'animation « smooth » du thème, ce qui donnait l'impression que
    // la page montait et descendait très vite. Bloquer l'appel à la
    // source évite ce combat. Le correctif plus bas (window.scrollTo(0,
    // verrou.y) dans l'écouteur scroll) doit rester : il rattrape tout
    // ce qui déplacerait la page sans passer par scrollTo (ex. le focus
    // automatique du thème sur le champ qu'on vient de choisir).
    var scrollToNatif = window.scrollTo.bind(window);
    window.scrollTo = function () {
      if (verrou.jusqua && Date.now() < verrou.jusqua) return;
      return scrollToNatif.apply(window, arguments);
    };

    // Seulement au vrai choix d'une variante. Un clic sur la copie des
    // pastilles actionne la vraie pastille, qui passe aussi par ici.
    document.addEventListener('change', function (e) {
      if (!estSelecteurVariante(e.target)) return;
      poserVerrou();

      // Nouvelle couleur : filtre et retour au début tout de suite,
      // sans attendre que le thème ait fini son travail.
      var couleur = currentColor();
      if (couleur && couleur !== lastColor) {
        // Vrai changement de couleur : on remet en avant la photo de la
        // nouvelle couleur, comme avant.
        tailleSeulement = false;
        verrouRangee.jusqua = Date.now() + 2500;
        var gallery = document.querySelector('media-gallery');
        if (gallery) etape('vedette en tete', function () { mettreVedetteEnTete(gallery); });

        // Le thème (media-gallery.js, natif Dawn) fait LUI AUSSI défiler la
        // rangée vers la nouvelle photo vedette (setActiveMedia), et comme
        // notre CSS met « scroll-behavior: smooth » sur cette rangée, son
        // défilement à lui s'anime pile au moment du changement de couleur —
        // on voit la rangée glisser d'une photo à l'autre pendant une
        // fraction de seconde, ce qui ressemble à un raté de chargement.
        // On coupe l'animation de défilement pour toute la durée du verrou :
        // n'importe quel scrollTo (le nôtre ou celui du thème) saute alors
        // instantanément, sans qu'on le voie glisser.
        etape('coupure du glissement animé', function () {
          var rail = gallery && gallery.querySelector('.product__media-list');
          if (rail) remettreAuDebut(rail, 2500);
        });

        refresh();
      } else {
        // Taille (ou toute autre option non-couleur) : la personne ne
        // change pas de photo, elle reste sur celle qu'elle regardait.
        // Empêche neutraliserSautTaille (plus bas) de laisser le thème
        // remettre la rangée sur la photo de la variante.
        tailleSeulement = true;
      }
    }, true);

    // Tout défilement de la rangée pendant le verrou est annulé.
    document.addEventListener('scroll', function (e) {
      if (!verrouRangee.jusqua) return;
      if (Date.now() > verrouRangee.jusqua) { verrouRangee.jusqua = 0; return; }
      var rail = e.target;
      if (!rail || !rail.matches || !rail.matches('media-gallery .product__media-list')) return;
      if (rail.scrollLeft > 1) remettreAuDebut(rail);
    }, true);

    // La personne touche les photos ou leurs flèches : verrou levé.
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (evenement) {
      document.addEventListener(evenement, function (e) {
        if (e.target && e.target.closest && e.target.closest('media-gallery')) verrouRangee.jusqua = 0;
      }, { passive: true, capture: true });
    });

    window.addEventListener('scroll', function () {
      if (!verrou.jusqua) return;
      if (Date.now() > verrou.jusqua) { verrou.jusqua = 0; return; }
      if (Math.abs(window.pageYOffset - verrou.y) > 2) {
        window.scrollTo(0, verrou.y);
      }
    }, { passive: true });

    // La personne reprend la main : on la laisse défiler.
    ['touchstart', 'wheel'].forEach(function (evenement) {
      window.addEventListener(evenement, function () {
        verrou.jusqua = 0;
      }, { passive: true });
    });
  }

  installerVerrou();

  // Tri appliqué tout de suite, avant même le premier affichage complet,
  // pour que la page s'ouvre sur la bonne photo.
  (function () {
    var galerieDepart = document.querySelector('media-gallery');
    if (galerieDepart) etape('tri au depart', function () { trierParNumero(galerieDepart); });
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();